import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useDispatch, useSelector } from 'react-redux';
import FJActionAIPhotoGenerator from '../../../../redux/action/FJActionAIPhotoGenerator.js';
import FJFilterAndSearch from '../view/FJFilterAndSearch.jsx';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import FJDropDownManager from '../../../../common/js/FJDropDownManager.js';

const FJFilterAndSearchContainer = () => {
    useLocalStore();
    const filterType = useSelector(state => state.aiPhotoGenerator.filterType);
    const searchText = useSelector(state => state.aiPhotoGenerator.searchText);
    const dispatch = useDispatch();

    const _onFilterTypeChange = value => {
        dispatch(FJActionAIPhotoGenerator.changeFilterTypeAction(value));
        dispatch(FJActionAIPhotoGenerator.updateHistoryListAction({ page: 1 }));
        dispatch(FJActionCommon.setSelectListAction([]));
        FJDropDownManager.hideAll();
    };

    const _onValueChange = value => {
        dispatch(FJActionAIPhotoGenerator.changeSearchTextAction(value));
    };

    const _onSubmit = () => {
        dispatch(FJActionAIPhotoGenerator.updateHistoryListAction({ page: 1 }));
        dispatch(FJActionCommon.setSelectListAction([]));
    };

    return (
        <FJFilterAndSearch
            filterType={filterType}
            searchText={searchText}
            onFilterTypeChange={_onFilterTypeChange}
            onSubmit={_onSubmit}
            onValueChange={_onValueChange}
        />
    );
};
export default FJFilterAndSearchContainer;
